// import React, { useState } from "react";
// import Header from "../Header/Header";
// import { useNavigate } from "react-router-dom";
// import TopRatedProducts from "./Components/TopRatedProducts";
// import DealsPage from "./Components/DealsPage";
// import Footer from "../../Components/Footer/Footer";
// const Home = () => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const navigate = useNavigate();

//   const handleToggle = () => {
//     setIsExpanded(!isExpanded);
//   };
//   const handleShopNowClick = () => {
//     navigate("/payment-gateway");
//   };

//   const handleAddToCart = (product) => {
//     // addToCart(product);
//     console.log("Item added to cart", product);
//   };

//   const handleSeeAll = () => {
//     navigate("/see-all");
//   };

//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   const products = [
//     {
//       id: 1,
//       name: "Perfect Blazer men for PartyWear",
//       price: 250,
//       discountPrice: 300,
//       img: "istockphoto-1092378606-612x612.jpg",
//     },
//     {
//       id: 2,
//       name: "Long Suit for Girls for PartyWear",
//       price: 250,
//       discountPrice: 300,
//       img: "istockphoto-526719098-612x612.jpg",
//     },
//     {
//       id: 3,
//       name: "Shoes for PartyWear",
//       price: 250,
//       discountPrice: 300,
//       img: "istockphoto-1308274455-612x612.jpg",
//     },
//     {
//       id: 4,
//       name: " Girls bag for PartyWear",
//       price: 250,
//       discountPrice: 300,
//       img: "istockphoto-1363767151-612x612.jpg",
//     },
//     {
//       id: 3,
//       name: "Polo T shirt for men",
//       price: 250,
//       discountPrice: 300,
//       img: "istockphoto-1416433020-640x640.jpg",
//     },
//   ];

//   return (
//     <div className="font-sans">
//       <Header />
//       {/* <CategoryNavbar /> */}
//      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 flex flex-col lg:flex-row justify-between items-center h-auto lg:h-[32rem] p-5">
//   <div className="pl-5 flex flex-col justify-center text-center lg:text-left">
//     <div className="bg-blue-100 text-blue-700 p-4 rounded-full mb-4 inline-block max-w-xs lg:max-w-sm text-center">
//       <p className="text-sm lg:text-base font-semibold">Premium Quality Furniture</p>
//     </div>
//     <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
//       Elevate Your Living Space <br />
//       <span className="font-bold text-gray-900">With Timeless</span>{" "}
//       <span className="font-bold text-indigo-600">Design & Comfort</span>
//     </h1>
//     <h5 className="text-lg lg:text-xl text-gray-600 mt-6 mb-8 max-w-2xl">
//       Discover handcrafted furniture that blends modern aesthetics with 
//       functional design. <br className="hidden lg:block" />
//       Transform your home with pieces that tell your story.
//     </h5>
   
//     <div className="mt-8 flex items-center gap-6 text-gray-600">
//       <div className="flex items-center gap-2">
//         <span className="text-green-500">✓</span>
//         <span>Free Shipping</span>
//       </div>
//       <div className="flex items-center gap-2">
//         <span className="text-green-500">✓</span>
//         <span>5-Year Warranty</span>
//       </div>
//       <div className="flex items-center gap-2">
//         <span className="text-green-500">✓</span>
//         <span>Customizable</span>
//       </div>
//     </div>
//   </div>
//   <div className="text-right mt-8 lg:mt-0 relative">
//     <img
//       src="assets/greenchair.png"
//       alt="Modern Luxury Sofa Set"
//       className="w-full max-w-lg lg:max-w-xl rounded-2xl h-auto"
//     />
   
//   </div>
// </div>
//       {/* <CategorySlider /> */}
//       <TopRatedProducts />
      
//       <DealsPage />
   
//       <Footer />
//     </div>
//   );
// };
// export default Home;

import React, { useState } from "react";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import TopRatedProducts from "./Components/TopRatedProducts";
import DealsPage from "./Components/DealsPage";
import Footer from "../../Components/Footer/Footer";

const Home = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  
  const handleShopNowClick = () => {
    navigate("/payment-gateway");
  };

  const handleAddToCart = (product) => {
    // addToCart(product);
    console.log("Item added to cart", product);
  };

  const handleSeeAll = () => {
    navigate("/see-all");
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const products = [
    {
      id: 1,
      name: "Perfect Blazer men for PartyWear",
      price: 250,
      discountPrice: 300,
      img: "istockphoto-1092378606-612x612.jpg",
    },
    {
      id: 2,
      name: "Long Suit for Girls for PartyWear",
      price: 250,
      discountPrice: 300,
      img: "istockphoto-526719098-612x612.jpg",
    },
    {
      id: 3,
      name: "Shoes for PartyWear",
      price: 250,
      discountPrice: 300,
      img: "istockphoto-1308274455-612x612.jpg",
    },
    {
      id: 4,
      name: " Girls bag for PartyWear",
      price: 250,
      discountPrice: 300,
      img: "istockphoto-1363767151-612x612.jpg",
    },
    {
      id: 3,
      name: "Polo T shirt for men",
      price: 250,
      discountPrice: 300,
      img: "istockphoto-1416433020-640x640.jpg",
    },
  ];

  return (
    <div className="font-sans">
      <Header />
      {/* Hero Section with reduced gap */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 flex flex-col lg:flex-row justify-between items-center h-auto lg:h-[32rem] p-4 lg:p-6">
        <div className="pl-0 lg:pl-5 flex flex-col justify-center text-center lg:text-left w-full lg:w-1/2">
          <div className="bg-blue-100 text-blue-700 p-3 lg:p-4 rounded-full mb-4 inline-block max-w-xs lg:max-w-md text-center">
            <p className="text-sm lg:text-base font-semibold">Premium Quality Furniture & Home Decor Solutions</p>
          </div>
          <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
  Transform Your Living Space Into A Masterpiece
  <br />
  <span className="block mt-3 font-bold text-gray-900">
    With Exquisite, Timeless
  </span>
  <span className="block font-bold text-indigo-600">
    Design & Unmatched Comfort
  </span>
</h1>

          <h5 className="text-base lg:text-lg text-gray-600 mt-4 lg:mt-6 mb-6 lg:mb-8 max-w-3xl">
            Discover our exclusive collection of handcrafted furniture that seamlessly blends contemporary aesthetics 
            with functional design excellence. Each piece is meticulously crafted to enhance your home's ambiance 
            while providing exceptional comfort and durability for years to come.
          </h5>
          
          <div className="mt-6 lg:mt-8 flex flex-wrap items-center gap-4 lg:gap-6 text-gray-600">
            <div className="flex items-center gap-2">
              <span className="text-green-500">✓</span>
              <span>Free Shipping Worldwide</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-green-500">✓</span>
              <span>Comprehensive 5-Year Warranty</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-green-500">✓</span>
              <span>Fully Customizable Designs</span>
            </div>
          </div>
        </div>
        
        <div className="mt-6 lg:mt-0 w-full lg:w-1/2 flex justify-center lg:justify-end">
          <img
            src="assets/greenchair.png"
            alt="Modern Luxury Sofa Set"
            className="w-full max-w-md lg:max-w-lg rounded-2xl h-auto object-cover"
          />
        </div>
      </div>
      
      {/* <CategorySlider /> */}
      <TopRatedProducts />
      
      <DealsPage />
   
      <Footer />
    </div>
  );
};

export default Home;